// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__pLgZl","list":"styles_list__22ec2"};